/* tslint:disable */
/* eslint-disable */
/**
 * Flawtrack Backend
 * Flawtrack ASM
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LogEntry } from './LogEntry';
import {
    LogEntryFromJSON,
    LogEntryFromJSONTyped,
    LogEntryToJSON,
    LogEntryToJSONTyped,
} from './LogEntry';

/**
 * 
 * @export
 * @interface Subdomain
 */
export interface Subdomain {
    /**
     * 
     * @type {number}
     * @memberof Subdomain
     */
    readonly id: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof Subdomain
     */
    readonly tags: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof Subdomain
     */
    readonly technologies: string;
    /**
     * 
     * @type {string}
     * @memberof Subdomain
     */
    readonly parentDomain: string;
    /**
     * 
     * @type {string}
     * @memberof Subdomain
     */
    readonly findingsStats: string;
    /**
     * 
     * @type {string}
     * @memberof Subdomain
     */
    readonly ports: string;
    /**
     * 
     * @type {Array<LogEntry>}
     * @memberof Subdomain
     */
    readonly history: Array<LogEntry>;
    /**
     * 
     * @type {string}
     * @memberof Subdomain
     */
    riskScore?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof Subdomain
     */
    isActive?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof Subdomain
     */
    readonly createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof Subdomain
     */
    readonly updatedAt: Date;
    /**
     * 
     * @type {string}
     * @memberof Subdomain
     */
    subdomainName: string;
    /**
     * 
     * @type {any}
     * @memberof Subdomain
     */
    dnsRecords?: any | null;
    /**
     * 
     * @type {any}
     * @memberof Subdomain
     */
    tlsCertificate?: any | null;
    /**
     * 
     * @type {number}
     * @memberof Subdomain
     */
    team: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof Subdomain
     */
    readonly ipAddresses: Array<number>;
}

/**
 * Check if a given object implements the Subdomain interface.
 */
export function instanceOfSubdomain(value: object): value is Subdomain {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('tags' in value) || value['tags'] === undefined) return false;
    if (!('technologies' in value) || value['technologies'] === undefined) return false;
    if (!('parentDomain' in value) || value['parentDomain'] === undefined) return false;
    if (!('findingsStats' in value) || value['findingsStats'] === undefined) return false;
    if (!('ports' in value) || value['ports'] === undefined) return false;
    if (!('history' in value) || value['history'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('subdomainName' in value) || value['subdomainName'] === undefined) return false;
    if (!('team' in value) || value['team'] === undefined) return false;
    if (!('ipAddresses' in value) || value['ipAddresses'] === undefined) return false;
    return true;
}

export function SubdomainFromJSON(json: any): Subdomain {
    return SubdomainFromJSONTyped(json, false);
}

export function SubdomainFromJSONTyped(json: any, ignoreDiscriminator: boolean): Subdomain {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'tags': json['tags'],
        'technologies': json['technologies'],
        'parentDomain': json['parent_domain'],
        'findingsStats': json['findings_stats'],
        'ports': json['ports'],
        'history': ((json['history'] as Array<any>).map(LogEntryFromJSON)),
        'riskScore': json['risk_score'] == null ? undefined : json['risk_score'],
        'isActive': json['is_active'] == null ? undefined : json['is_active'],
        'createdAt': (new Date(json['created_at'])),
        'updatedAt': (new Date(json['updated_at'])),
        'subdomainName': json['subdomain_name'],
        'dnsRecords': json['dns_records'] == null ? undefined : json['dns_records'],
        'tlsCertificate': json['tls_certificate'] == null ? undefined : json['tls_certificate'],
        'team': json['team'],
        'ipAddresses': json['ip_addresses'],
    };
}

  export function SubdomainToJSON(json: any): Subdomain {
      return SubdomainToJSONTyped(json, false);
  }

  export function SubdomainToJSONTyped(value?: Omit<Subdomain, 'id'|'tags'|'technologies'|'parent_domain'|'findings_stats'|'ports'|'history'|'created_at'|'updated_at'|'ip_addresses'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'risk_score': value['riskScore'],
        'is_active': value['isActive'],
        'subdomain_name': value['subdomainName'],
        'dns_records': value['dnsRecords'],
        'tls_certificate': value['tlsCertificate'],
        'team': value['team'],
    };
}

